import React from "react";
import ImagerApi from "../../api/ImagerApi";
import IconWarning from "../../Icons/NotificationMessage/Warning";
import MtiButton from "../Buttons/MtiButton";
import Modal from "../Common/Modal";
import "./ClearDropLocationWarning.css";
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import { getModuleStateById } from "../../redux/reducers/ModuleStateReducer";

type Props = {
  onClose: (clearDropLocationOverride: boolean) => void;
  allDrop: boolean;
  plateBarcode: string;
  wellNumber?: number;
  dropNumber?: number;
};

export default function ClearDropLocationWarning({
  plateBarcode,
  allDrop,
  onClose,
  wellNumber = 0,
  dropNumber = 0,
}: Props) {
  const suiteState = useTypedSelector((state) => getModuleStateById(state)["SUITE"]?.suite);
  const onClick = (clearDropLocationOverride: boolean) => {
    if (allDrop) {
      ImagerApi.clearDropLocation(plateBarcode, clearDropLocationOverride).finally(() =>
        onClose(clearDropLocationOverride)
      );
    } else {
      ImagerApi.clearDropLocation(plateBarcode, clearDropLocationOverride, wellNumber, dropNumber).finally(() =>
        onClose(clearDropLocationOverride)
      );
    }
  };

  const title = allDrop ? "Clear All Drop Locations" : "Clear Current Drop Location";

  return (
    <Modal show={true}>
      <Modal.Header title={title} hideButtonEnabled={false} />
      <Modal.Body>
        <div className="body-text">
          {allDrop && (
            <p>
              Do you also want to remove the manual drop location overrides for this plate in{" "}
              {suiteState?.limsName ?? "LIMS"}?
            </p>
          )}
          {!allDrop && (
            <p>
              Do you also want to remove the manual drop location overrides for this drop in{" "}
              {suiteState?.limsName ?? "LIMS"}?
            </p>
          )}
        </div>
        {allDrop && (
          <div className="warning-container">
            <div className="icon-container">
              <IconWarning width={24.08} height={22.67} />
            </div>
            <div className="text-containert">
              <p>This action will clear all drop locations in the plate.</p>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer
        style={{
          marginTop: 36,
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <MtiButton style={{ width: 148, marginRight: 10 }} onClick={() => onClick(true)}>
          Yes
        </MtiButton>
        <MtiButton style={{ width: 148 }} onClick={() => onClick(false)}>
          No
        </MtiButton>
      </Modal.Footer>
    </Modal>
  );
}
